import React, { useState, useEffect } from "react";
import axios from "axios";
import heroImageFallback from "../../images/slider/slider-ariana-inner.JPG";
import AdminImageZoom from "../AdminImageZoom";
import "./style.css";

const WHATSAPP_NUMBER = "40743222996";

const WhatsAppModal = ({ onClose }) => {
  const [name, setName] = useState("");

  const handleSend = () => {
    const participantName = name.trim();
    axios
      .post(`${process.env.REACT_APP_API_BASE}/participants/palm-massage/post`, {
        name: participantName,
      })
      .catch((error) => {
        console.error("Înscrierea pentru sesiunea de masaj nu a putut fi salvată.", error);
      });

    const text = encodeURIComponent(
      `Bună, Ariana!\nNumele meu este ${participantName}.\nVreau să particip la sesiunea de masaj în palmă 🤲`
    );
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`,
      "_blank",
      "noopener,noreferrer"
    );
    onClose();
  };

  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="hero-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="hero-modal" onClick={(e) => e.stopPropagation()}>

        <button className="hero-modal__close" onClick={onClose} aria-label="Închide">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Big serif title — inherits design system sizes */}
        <h3 className="enhanced-wellnews__title hero-modal__title">Înscrie-te</h3>
        <p className="enhanced-wellnews__subtitle hero-modal__subtitle">la sesiunea de masaj <br></br>în palmă</p>

        {/* Underline field with uppercase label */}
        <div className="hero-modal__form">
          <label className="hero-modal__field">
            <span className="hero-modal__label">Nume</span>
            <input
              className="hero-modal__input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && name.trim()) handleSend(); }}
              autoFocus
              maxLength={80}
            />
          </label>
        </div>

        <button
          className="hero-modal__submit"
          onClick={handleSend}
          disabled={!name.trim()}
        >
          Trimite
        </button>
      </div>
    </div>
  );
};

const BloomHero = () => {
  const [btnText, setBtnText] = useState(() => {
    // Read synchronously from pre-fetched window object if already available.
    // This avoids a separate API call on component mount.
    const t = window.__SITE_TEXT__;
    if (t && t.heroButtonText) return t.heroButtonText;
    return "Participă";
  });
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    // If the pre-fetch hasn't resolved yet, await its promise.
    if (window.__SITE_TEXT__ && window.__SITE_TEXT__.heroButtonText) return;
    const p = window.__SITE_TEXT_PROMISE__;
    if (p) {
      p.then((d) => { if (d && d.heroButtonText) setBtnText(d.heroButtonText); })
       .catch(() => {});
      return;
    }
    // Fallback: direct API call (very old cached HTML without the pre-fetch script)
    axios
      .get(`${process.env.REACT_APP_API_BASE}/settings/get?category=siteDesign`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length > 0 && data[0].heroButtonText) setBtnText(data[0].heroButtonText);
      })
      .catch(() => {/* use defaults */});
  }, []);

  return (
    <>
      <section className="new-hero" id="scrool">
        <div className="new-hero__bg">
          <AdminImageZoom
            settingKey="heroImageScale"
            imageKey="heroImage"
            desktopSettingKey="heroDesktopImageScale"
            desktopImageKey="heroDesktopImage"
            src={heroImageFallback}
            alt="The Oils Babe"
            variant="cover"
            min={0.5}
            max={3}
          />
          <div className="new-hero__overlay"></div>
        </div>
        <div className="new-hero__content">
          <h1 className="new-hero__title">
            {/* Începe propria călătorie spre echilibru, calm și wellbeing. */}
            Înscrie-te la o sesiune de masaj în palmă
          </h1>
          <div className="new-hero__buttons">
            <button
              className="new-hero__btn new-hero__btn--primary"
              onClick={() => setModalOpen(true)}
            >
              {btnText}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {modalOpen && <WhatsAppModal onClose={() => setModalOpen(false)} />}
    </>
  );
};

export default BloomHero;
